// extracted by mini-css-extract-plugin
export default {"address-card-preview":"address-card-preview--I-N9+zBWmb","addressCardPreview":"address-card-preview--I-N9+zBWmb","title":"title--XUIIYHt4RS","flags":"flags--WtJ3D0B3P3"};